document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.review-platform-btn');

  buttons.forEach((button) => {
    button.addEventListener('mouseenter', () => {
      button.classList.add('is-active');
    });

    button.addEventListener('mouseleave', () => {
      button.classList.remove('is-active');
    });

    button.addEventListener('focus', () => {
      button.classList.add('is-active');
    });

    button.addEventListener('blur', () => {
      button.classList.remove('is-active');
    });
  });
});

/* ==========================================================
   Reviews Landing Page
========================================================== */
document.addEventListener("DOMContentLoaded", () => {
    initReviewFaq();
});
/* ==========================================================
   FAQ Accordion
========================================================== */
function initReviewFaq() {
    const faqItems = document.querySelectorAll(".faq-item");
    if (!faqItems.length) return;
    faqItems.forEach((item) => {
        const button = item.querySelector(".faq-question");
        const answer = item.querySelector(".faq-answer");
        if (!button || !answer) return;
        button.setAttribute("aria-expanded", "false");
        answer.style.maxHeight = "0px";
        button.addEventListener("click", () => {
            const isOpen = item.classList.contains("active");
            /* Close all */
            faqItems.forEach((faq) => {
                faq.classList.remove("active");
                const btn = faq.querySelector(".faq-question");
                const panel = faq.querySelector(".faq-answer");
                if (btn) {
                    btn.setAttribute("aria-expanded", "false");
                }
                if (panel) {
                    panel.style.maxHeight = null;
                }
            });
            /* Open clicked */
            if (!isOpen) {
                item.classList.add("active");
                button.setAttribute("aria-expanded", "true");
                answer.style.maxHeight =
                    answer.scrollHeight + "px";
            }
        });
    });
}